/**
 * TRIDOO — Scelta di colore e razza dei portasacchetti Kibbu.
 *
 * Il cambio variante resta tutto del tema: i radio stanno dentro
 * <variant-selects>, che aggiorna ID, foto, prezzo, disponibilità e barra
 * d'acquisto. Qui si guida solo il contorno:
 *   - sul telefono il campo Razza apre la griglia in un <dialog> modale
 *     (Esc, X o tocco fuori per chiudere; il focus torna al campo);
 *   - la ricerca filtra le razze per nome;
 *   - il campo mostra subito testa e nome della razza toccata;
 *   - la riga dei colori, che scorre, tiene in vista il colore scelto.
 */
if (!window.tridooPortasacchettiPicker) {
  window.tridooPortasacchettiPicker = true;

  const telefono = window.matchMedia('(max-width: 767.98px)');
  const BLOCCO = 'kibbu-pannello-aperto';

  // La ricerca non è un'opzione di variante: il suo `change` non deve
  // arrivare a <variant-selects>, che ascolta in cattura e lo prenderebbe
  // per una scelta. Fermato qui, sopra di lui, sempre in cattura.
  window.addEventListener(
    'change',
    (evento) => {
      if (evento.target instanceof Element && evento.target.matches('[data-kibbu-breed-cerca]')) {
        evento.stopPropagation();
      }
    },
    true
  );

  const normalizza = (testo) =>
    String(testo || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .trim();

  const filtra = (pannello, testo) => {
    const cerca = normalizza(testo);
    let trovate = 0;
    pannello.querySelectorAll('.kibbu-breed-card').forEach((carta) => {
      const visibile = !cerca || normalizza(carta.textContent).includes(cerca);
      carta.hidden = !visibile;
      // Anche il radio: con le frecce non si finisce su una razza nascosta.
      const radio = document.getElementById(carta.htmlFor);
      if (radio) radio.hidden = !visibile;
      if (visibile) trovate += 1;
    });
    const vuoto = pannello.querySelector('[data-kibbu-breed-vuoto]');
    if (vuoto) vuoto.hidden = trovate > 0;
  };

  const apri = (picker) => {
    const pannello = picker.querySelector('[data-kibbu-breed-panel]');
    if (!pannello || pannello.open || typeof pannello.showModal !== 'function') return false;
    // Il details resta aperto finché c'è il pannello: il contenuto di un
    // details chiuso non si vede e non prende il focus, nemmeno in un modale.
    picker.open = true;
    pannello.showModal();
    document.documentElement.classList.add(BLOCCO);
    sorveglia(pannello);
    // Niente focus sulla ricerca: aprirebbe subito la tastiera sopra la
    // griglia. Il focus va sulla razza scelta, che si porta in vista.
    const scelta = pannello.querySelector('input[data-kibbu-breed]:checked');
    if (scelta) {
      scelta.focus({ preventScroll: true });
      const carta = pannello.querySelector(`label[for="${CSS.escape(scelta.id)}"]`);
      if (carta) carta.scrollIntoView({ block: 'center' });
    }
    return true;
  };

  // Dopo ogni scelta il tema riallinea il selettore all'HTML ricevuto,
  // attributi compresi: toglie `open` al dialog e al details, che nell'HTML
  // del server non ci sono. Se la chiusura l'ha chiesta chi compra (X, Esc,
  // sfondo, razza scelta) va bene così; se arriva dal riallineamento di una
  // scelta precedente (un colore toccato un attimo prima di aprire il
  // pannello) il pannello si riapre com'era.
  const sorveglia = (pannello) => {
    if (pannello._sorvegliato || !('MutationObserver' in window)) return;
    pannello._sorvegliato = true;
    const picker = pannello.closest('[data-kibbu-breed-picker]');
    const osserva = { attributes: true, attributeFilter: ['open'] };
    const guardia = new MutationObserver(() => {
      if (pannello.open) return;
      // Tolto l'attributo a un dialog modale, Chrome lo lascia in primo piano
      // e invisibile: la pagina resta bloccata ai tocchi. Si rimette `open`
      // e lo si chiude come si deve, senza farsi vedere da questa guardia.
      if (pannello.matches(':modal')) {
        guardia.disconnect();
        pannello.setAttribute('open', '');
        pannello.close();
        guardia.observe(pannello, osserva);
      } else if (document.documentElement.classList.contains(BLOCCO)) {
        pannello.dispatchEvent(new Event('close'));
      }
      if (pannello._voluta) {
        pannello._voluta = false;
        return;
      }
      setTimeout(() => {
        if (pannello.open || !picker) return;
        picker.open = true;
        pannello.showModal();
        document.documentElement.classList.add(BLOCCO);
      }, 0);
    });
    guardia.observe(pannello, osserva);
    if (picker) {
      new MutationObserver(() => {
        if (picker.open || !pannello.open) return;
        if (pannello._voluta) pannello.close();
        else picker.open = true;
      }).observe(picker, { attributes: true, attributeFilter: ['open'] });
    }
  };

  const chiudi = (pannello) => {
    if (!pannello || !pannello.open) return;
    pannello._voluta = true;
    pannello.close();
  };

  // Esc: la chiude il browser, ma la chiede chi compra.
  document.addEventListener(
    'cancel',
    (evento) => {
      if (evento.target instanceof HTMLDialogElement && evento.target.matches('[data-kibbu-breed-panel]')) {
        evento.target._voluta = true;
      }
    },
    true
  );

  // Sul telefono il tocco sul campo apre il pannello invece del details.
  document.addEventListener('click', (evento) => {
    const bersaglio = evento.target instanceof Element ? evento.target : null;
    if (!bersaglio) return;

    const campo = bersaglio.closest('[data-kibbu-breed-picker] > summary');
    if (campo) {
      if (telefono.matches && apri(campo.parentElement)) evento.preventDefault();
      return;
    }

    const x = bersaglio.closest('[data-kibbu-breed-chiudi]');
    if (x) {
      chiudi(x.closest('[data-kibbu-breed-panel]'));
      return;
    }

    // Tocco sullo sfondo: il dialog riceve il click fuori dal suo riquadro.
    if (bersaglio.matches('[data-kibbu-breed-panel]')) {
      const r = bersaglio.getBoundingClientRect();
      const fuori =
        evento.clientX < r.left || evento.clientX > r.right || evento.clientY < r.top || evento.clientY > r.bottom;
      if (fuori) chiudi(bersaglio);
    }
  });

  // `close` non risale: lo si prende in cattura.
  document.addEventListener(
    'close',
    (evento) => {
      const pannello = evento.target;
      if (!(pannello instanceof HTMLDialogElement) || !pannello.matches('[data-kibbu-breed-panel]')) return;
      document.documentElement.classList.remove(BLOCCO);
      const cerca = pannello.querySelector('[data-kibbu-breed-cerca]');
      if (cerca && cerca.value) {
        cerca.value = '';
        filtra(pannello, '');
      }
      const picker = pannello.closest('[data-kibbu-breed-picker]');
      if (picker && picker.open && telefono.matches) picker.open = false;
      const campo = picker?.querySelector('summary');
      if (campo) campo.focus({ preventScroll: true });
    },
    true
  );

  document.addEventListener('input', (evento) => {
    const cerca = evento.target;
    if (!(cerca instanceof HTMLInputElement) || !cerca.matches('[data-kibbu-breed-cerca]')) return;
    const pannello = cerca.closest('[data-kibbu-breed-panel]');
    if (pannello) filtra(pannello, cerca.value);
  });

  // La riga dei colori scorre: il colore scelto deve stare in vista, anche
  // quando arriva da un link diretto alla variante.
  const centraColore = (riga) => {
    if (!riga || riga.scrollWidth <= riga.clientWidth) return;
    const scelto = riga.querySelector('input[data-kibbu-color]:checked');
    const tessera = scelto && riga.querySelector(`label[for="${CSS.escape(scelto.id)}"]`);
    if (!tessera) return;
    riga.scrollLeft = Math.max(0, tessera.offsetLeft - (riga.clientWidth - tessera.offsetWidth) / 2);
  };

  // Il campo dice subito la razza toccata; il pannello si chiude da solo
  // dopo un attimo, il tempo di vedere la spunta.
  document.addEventListener('change', (evento) => {
    const scelta = evento.target;
    if (!(scelta instanceof HTMLInputElement)) return;

    if (scelta.matches('[data-kibbu-color]')) {
      centraColore(scelta.closest('.kibbu-color-row'));
      return;
    }
    if (!scelta.matches('[data-kibbu-breed]')) return;

    const picker = scelta.closest('[data-kibbu-breed-picker]');
    const immagine = picker?.querySelector('[data-kibbu-current-breed]');
    if (immagine && scelta.dataset.kibbuPreview) {
      immagine.src = scelta.dataset.kibbuPreview;
      immagine.removeAttribute('srcset');
    }
    const nome = picker?.querySelector('[data-kibbu-current-name]');
    if (nome) nome.textContent = scelta.value;

    const pannello = scelta.closest('[data-kibbu-breed-panel]');
    if (pannello && pannello.open) {
      // Da qui la chiusura è voluta, anche se il tema arriva prima dei 150ms.
      pannello._voluta = true;
      setTimeout(() => chiudi(pannello), 150);
    }
  });

  const centraTutti = () =>
    document.querySelectorAll('.kibbu-color-row').forEach((riga) => centraColore(riga));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', centraTutti, { once: true });
  } else {
    centraTutti();
  }
  telefono.addEventListener('change', centraTutti);
}
